import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import countryPriceApi from "../../../api/countryPriceApi";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";
import frymesOrderApi from "../../../api/frymeOrderApi";
import resellingPriceApi from "../../../api/resellingPriceApi";
import { currencyConfig } from "../../../components/utils/currencyConfig";
import QRCodeModal from "../../../dashboard/pages/credits/Payment/QRCodeModal";

const BuyFrymes = () => {
  const [priceRange, setPriceRange] = useState(null);
  const [l1PriceData, setL1PriceData] = useState(null);
  const [error, setError] = useState(null);

  const [selectedPriceType, setSelectedPriceType] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [frymesCount, setFrymesCount] = useState("");
  const [totalCost, setTotalCost] = useState(0);

  const email = Cookies.get("userEmail");
  const countryCode = Cookies.get("country");

  const [data, setData] = useState();

  const [showQR, setShowQR] = useState(false);
  const [qrImage, setQrImage] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [amountToPay, setAmountToPay] = useState(0);
  const [ledger, setLedger] = useState([]);
  // ROLE LOGIC
  const isParentCookie = Cookies.get("isParent");

  let visibilityRole = "CUSTOMER";

  if (isParentCookie == "true") {
    visibilityRole = "L1_ADMIN";
  } else if (isParentCookie == "false") {
    visibilityRole = "L2_ADMIN";
  }

  useEffect(() => {
    if (email) {
      frymesOrderApi
        .getLedger(email)
        .then((res) => {
          setLedger(res.data);
        })
        .catch((err) => {
          console.error("Error fetching ledger details:", err);
        });
    }
  }, [email]);
  // FETCH FRANCHISE DETAILS
  useEffect(() => {
    if (email) {
      franchiseAdminAPI
        .getFranchiseDetailsByEmail(email)
        .then((res) => {
          setData({
            organization: res.data.organization,
            id: res.data.id,
            location: res.data.location,
          });
        })
        .catch((err) => {
          console.error("Error fetching franchise details:", err);
        });
    }
  }, [email]);

  // FETCH COUNTRY PRICE BASED ON ROLE
  useEffect(() => {
    if (!countryCode) {
      setError("Country code not found in cookies");

      toast.error("Country code not found in cookies");

      return;
    }

    console.log(countryCode, visibilityRole);

    countryPriceApi
      .getCountryPriceByCodeAndRole(countryCode, visibilityRole)
      .then((res) => {
        console.log("API RESPONSE:", res.data);

        if (res.data && res.data.length > 0) {
          setPriceRange(res.data[0]);
          setError(null);
        } else {
          setError("No Master Admin pricing found for this role");
        }
      })
      .catch((err) => {
        console.error("API ERROR:", err);

        setError("Failed to fetch Master Admin price range");

        toast.error("Failed to fetch price range");
      });
  }, [countryCode, visibilityRole]);

  // FETCH L1 PRICE
  useEffect(() => {
    if (isParentCookie === "false" && email) {
      resellingPriceApi
        .getParentPrices(email)
        .then((res) => {
          if (res.data && res.data.pricing && res.data.pricing.sellingPrice) {
            setL1PriceData({
              ...res.data.pricing,
              parentId: res.data.parentId
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching L1 price:", err);
        });
    }
  }, [isParentCookie, email]);

  // SET DEFAULT SELECTED PRICE
  useEffect(() => {
    if (l1PriceData) {
      setSelectedPriceType("L1_PRICE");
    } else if (priceRange) {
      setSelectedPriceType("MASTER_PRICE");
    }
  }, [l1PriceData, priceRange]);

  // CALCULATE TOTAL COST
  useEffect(() => {
    const activePrice = selectedPriceType === "L1_PRICE" ? l1PriceData?.sellingPrice : priceRange?.minPrice;
    const total = Number(activePrice || 0) * Number(frymesCount || 0);

    setTotalCost(total);
    setSelectedPrice(activePrice);
  }, [priceRange?.minPrice, l1PriceData?.sellingPrice, selectedPriceType, frymesCount]);

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const activePrice = selectedPriceType === "L1_PRICE" ? l1PriceData?.sellingPrice : priceRange?.minPrice;

    if (!activePrice) return;

    if (!frymesCount || frymesCount <= 0) {
      toast.warning("Please enter valid frymes quantity");
      return;
    }

    const currencyData = currencyConfig[countryCode];

    const payload = {
      buyerFranchiseId: data?.id,
      quantity: Number(frymesCount),
      unitPrice: Number(activePrice),
      totalAmount: Number(frymesCount) * Number(activePrice),
      countryCode: countryCode,
      currencyCode: currencyData?.currency,
      currencySymbol: currencyData?.symbol,
    };

    if (selectedPriceType === "L1_PRICE" && l1PriceData?.parentId) {
      payload.sellerFranchiseId = l1PriceData.parentId;
    }

    try {
      await frymesOrderApi.saveFrymeRequest(payload);

      toast.success("Frymes request submitted successfully!");

      setFrymesCount("");
      setTotalCost(0);
    } catch (err) {
      console.error(err);

      toast.error("Failed to submit request. Try again.");

      Swal.fire({
        title: "Error!",
        text: "Failed to submit request. Try again.",
        icon: "error",
      });
    }
  };

  // CLOSE QR
  const handleCloseQR = async () => {
    setShowQR(false);
    setFrymesCount("");
  };

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />

      <div className="card shadow p-4">
        
        {error && !l1PriceData && !priceRange && (
          <>
            {isParentCookie !== "false" && (
              <h2 className="mb-3">
                Buy Frymes From Master Admin{" "}
                <span className="text-primary">({countryCode})</span>
              </h2>
            )}

            <div className="alert alert-danger">{error}</div>
          </>
        )}
        {priceRange || l1PriceData ? (
          <>
            {/* PRICE */}
            <div className="mb-3">
              {l1PriceData && priceRange ? (
                <div>
                  <label className="form-label fw-bold">Select Price Option:</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="priceSelection"
                      id="l1PriceOption"
                      value="L1_PRICE"
                      checked={selectedPriceType === "L1_PRICE"}
                      onChange={() => setSelectedPriceType("L1_PRICE")}
                    />
                    <label className="form-check-label" htmlFor="l1PriceOption">
                      Franchise Base price: <strong>{l1PriceData.sellingPrice} {currencyConfig[countryCode]?.symbol || l1PriceData.currencySymbol} ({l1PriceData.countryCode})</strong>
                    </label>
                  </div>
                  <div className="form-check mt-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="priceSelection"
                      id="masterPriceOption"
                      value="MASTER_PRICE"
                      checked={selectedPriceType === "MASTER_PRICE"}
                      onChange={() => setSelectedPriceType("MASTER_PRICE")}
                    />
                    <label className="form-check-label" htmlFor="masterPriceOption">
                      Master Admin price: <strong>{priceRange.minPrice} {priceRange.currencySymbol} ({priceRange.currencyCode})</strong>
                    </label>
                  </div>
                </div>
              ) : l1PriceData ? (
                <div className="alert alert-info mb-1">
                  Your Franchise L1 Admin has set price:{" "}
                  <strong>
                    {l1PriceData.sellingPrice} {currencyConfig[countryCode]?.symbol || l1PriceData.currencySymbol} ({l1PriceData.countryCode})
                  </strong>
                </div>
              ) : (
                <div className="alert alert-info mb-1">
                  Base Price Per Frymes:{" "}
                  <strong>
                    {priceRange.minPrice} {priceRange.currencySymbol} ({priceRange.currencyCode})
                  </strong>
                </div>
              )}
            </div>

            {/* FORM */}
            <form onSubmit={handleSubmit}>
              {/* QUANTITY */}
              <div className="mb-3">
                <label className="form-label">
                  Number Of Frymes
                  <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter frymes quantity"
                  value={frymesCount}
                  onChange={(e) => setFrymesCount(e.target.value)}
                />
              </div>

              {/* TOTAL */}
              <div className="mb-3">
                <label className="form-label">Total Cost</label>

                <input
                  type="text"
                  className="form-control"
                  value={totalCost}
                  readOnly
                />
              </div>

              <button type="submit" className="btn btn-success">
                Buy Frymes
              </button>
            </form>
          </>
        ) : (
          !error && <p className="text-muted">Loading...</p>
        )}
      </div>

      {/* QR MODAL */}
      <QRCodeModal
        show={showQR}
        handleClose={handleCloseQR}
        qrImage={qrImage}
        credits={frymesCount}
        price={selectedPrice}
        amount={amountToPay}
        transactionId={transactionId}
        franchise={data?.organization}
        location={data?.location}
        country={countryCode}
        managedBy={email}
        requestedFrom={
          visibilityRole === "L2_ADMIN"
            ? "Franchise L2"
            : visibilityRole === "L1_ADMIN"
              ? "Franchise L1"
              : "Customer"
        }
        requestedTo={selectedPriceType === "L1_PRICE" ? "Franchise L1" : "Master Admin"}
      />
    </div>
  );
};

export default BuyFrymes;
